// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__woiKt","noSuchPageTitle":"NotFound_noSuchPageTitle__GEJv9","noSuchPageText":"NotFound_noSuchPageText__2AM8Z","backToShop":"NotFound_backToShop__0qdJU"};